import(/* webpackMode: "eager", webpackExports: ["ForgotView"] */ "/app/src/features/auth/components/forgot/forgot-view.tsx");
